import React from 'react'

interface Props {
  children?: React.ReactNode
  title?: string
  helm?: string
}

export const LayoutPage = ({ title, children, helm }: Props) => {
  const pageTitle = helm ?? title
  return (
    <>
      {pageTitle && <title>{pageTitle}</title>}
      {children}
    </>
  )
}
